/* eslint-disable */
import * as types from '../../actions/types';

const initialState = ''

export default function token (state = initialState, action) {
  switch (action.type) {
        
    case types.SET_TESTING_TOKEN:
      return action.payload

    default:
      return state;
  }
}